import React from 'react';
import { getThemeColors } from '../../../lib/theme';
import { ABSENCE_COLOR, PAUSE_COLOR, OVERLAY_OPACITY } from './types';
import type { AbsenceTimelineBar } from './types';
import { isPauseGrund } from './helpers';
import { bkAvailabilityByGrund } from '../../../lib/bkAvailability';

interface Props {
  bar: AbsenceTimelineBar;
  dark: boolean;
  onClick?: () => void;
  /**
   * Beschriftung zeigen? Liegt die Abwesenheit über einer Betreuung, bleibt
   * sie unbeschriftet (Tooltip genügt), damit der Betreuungstext lesbar ist.
   */
  showLabel?: boolean;
  /**
   * Liegt der Balken in der Zeile der Betreuungen (Vertragspause)? Dann
   * halbtransparent darüber; in der eigenen Zeile (Krankenhaus) deckend.
   */
  overlay?: boolean;
}

/**
 * Abwesenheits-Balken — Vertragspausen halbtransparent ÜBER den Betreuungen
 * (Zeile 0), Krankenhaus-Abwesenheiten deckend in der zweiten Zeile.
 */
export function AbsenceBarView({ bar, dark, onClick, showLabel = true, overlay = true }: Props) {
  const tc = getThemeColors(dark);
  const top = 44 + bar.row * 30;
  // BK-Verfügbarkeit (Verfügbarkeit / Urlaub / Kein Kontakt) hat je Art eine eigene Farbe.
  const barColor = isPauseGrund(bar.grundRaw)
    ? PAUSE_COLOR
    : (bkAvailabilityByGrund(bar.grundRaw)?.color ?? ABSENCE_COLOR);
  return (
    <div
      title={bar.tooltip}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      style={{
        position: 'absolute', left: `${bar.left}%`, width: `${bar.width}%`, top, height: 20,
        minWidth: 22, borderRadius: 999, background: barColor, color: '#fff',
        opacity: overlay ? OVERLAY_OPACITY : 1, zIndex: 2,
        display: 'flex', alignItems: 'center', padding: '0 9px', overflow: 'hidden',
        fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', border: `1px solid ${tc.card}`,
        cursor: onClick ? 'pointer' : 'default',
        backgroundImage: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.18) 0 6px, transparent 6px 12px)',
      }}
    >
      {showLabel && bar.width > 10 ? bar.grund : ''}
    </div>
  );
}
